import { render, staticRenderFns } from "./LedgerDraftItem.vue?vue&type=template&id=2a0670fa&"
import script from "./LedgerDraftItem.vue?vue&type=script&lang=js&"
export * from "./LedgerDraftItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports